<template>
  <v-layout column :class="{ 'pa-4': $vuetify.breakpoint.smAndUp }">
    <v-breadcrumbs class=" pl-0" :class="{ 'mx-3': $vuetify.breakpoint.xs }">
      <v-icon #divider aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
      <router-link to="/">
        <v-breadcrumbs-item>
          <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
          {{ $t("Главная") }}
        </v-breadcrumbs-item>
      </router-link>
      <router-link :to="parentRoute">
        <v-breadcrumbs-item>
          <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
          {{ $t("Обучение") }}
        </v-breadcrumbs-item>
      </router-link>
    </v-breadcrumbs>
    <template v-if="!loading">
      <h1
          v-if="if_stepper_showed"
          class="section-title-main my-3 font-weight-regular"
          :class="{ 'px-3': $vuetify.breakpoint.xs }"
      >
        {{ isScorm ? scormName : course_name }}
      </h1>
      <courseHeader
          v-if="if_stepper_showed"
          :class="{ 'px-3': $vuetify.breakpoint.xs }"
          :courseData="currentCourseData"
      />

      <v-layout
          row
          wrap
          :class="{
                    'mt-5': $vuetify.breakpoint.mdAndUp,
                    'mb-5': $vuetify.breakpoint.smAndUp && !test_layout
                }"
      >
        <!-- Left sidebar -->
        <courseAside
            v-if="if_stepper_showed"
            class="md3"
            :is-scorm-course-shown="isScormCourseShown"
            :is-scorm-test-started="isScormTestStarted"
            :is-scorm="isScorm"
            :is-business-plus="isBusinessPlus"
            :is-disabled-by-user-status="isDisabledByUserStatus"
            @update:isScormCourseShown="handleScormCourseShown"
            @update:isScormTestStarted="handleScormTestStarted"
            @update:isScormTestActivated="handleManualActivationStatusChange"
        />
        <!-- Content -->
        <v-layout
            v-if="
                        $vuetify.breakpoint.smAndDown && content_mobile_showed
                    "
            align-center
            class="course__nav-back py-3"
            :class="{ 'mb-4': $vuetify.breakpoint.smAndDown }"
            @click="hide_wrap()"
        >
          <svg
              v-svg
              symbol="arrow-left"
              size="12 24"
              class="icon red-text mx-3"
              role="presentation"
          />
          <v-flex xs10>
            {{ course_name }}
          </v-flex>
        </v-layout>


        <!-- SCORM content -->
        <courseContent
            v-if="!test_layout && isScorm && isScormCourseShown"
            :test_layout="test_layout"
            :isScorm="isScorm"
            class="md9 sm12 js-course-content"
            :class="{
                        'pl-0': $vuetify.breakpoint.smAndDown,
                        'pl-5': $vuetify.breakpoint.mdAndUp
                    }"
        />
        <div
            v-if="isScorm && !isScormCourseShown && !isDisabledByUserStatus && !isTestFinished && isCurrentCourse"
            class="md9 sm12 js-course-content scorm-course"
            :class="{
                        'pl-0': $vuetify.breakpoint.smAndDown,
                        'pl-5': $vuetify.breakpoint.mdAndUp
                    }"
        >
          <div style="margin-bottom: 32px">
            <h3 v-if="isScormTestStarted">Для завершения тестирования по окончании нажмите кнопку <span style="color: #e2173d">"Завершить курс"</span></h3>
            <h3 v-else-if="!isScormTestStarted">Для прохождения тестирования нажмите кнопку <span style="color: #e2173d">”Начать тест"</span></h3>
          </div>
          <iframe
              ref="scormIframe"
              :src="scormPath"
              width="100%"
              height="800px"
              frameborder="0"
          >
          </iframe>
        </div>

        <div
            v-if="isScorm && !isScormCourseShown && !isDisabledByUserStatus && isTestFinished"
        >
          <article style="padding: 8px 32px; font-size: 20px; font-weight: 600">
            <p>Вы уже завершили данный курс. Повторное прохождение недоступно.</p>
          </article>
        </div>

        <div
            v-if="isScorm && isDisabledByUserStatus && !isTestFinished"
        >
          <article style="padding: 8px 32px; font-size: 20px; font-weight: 600">
            <p>Прохождение данного курса доступно только для пользователей со статусом "Эксперт"</p>
          </article>
        </div>

        <!-- Обычный курс -->
        <courseContent
            v-if="!test_layout && if_course_showed && !isScorm"
            :test_layout="test_layout"
            class="md9 sm12 js-course-content"
            :class="{
                        'pl-0': $vuetify.breakpoint.smAndDown,
                        'pl-5': $vuetify.breakpoint.mdAndUp
                    }"
        />
        <!-- Test content -->
        <v-flex
            v-if="test_layout && if_course_showed"
            md9
            :class="{ 'pl-5': $vuetify.breakpoint.mdAndUp }"
            class="js-test-content"
        >
          <question :test_hide="test_hided" :test_layout="test_layout" />
        </v-flex>
      </v-layout>
      <!-- Modals -->
      <modal-test v-if="modal_test.active" />
      <modal-success v-if="modal_success.active" />
      <modal-failed v-if="modal_failed.active" />
      <modalTestCancel v-if="modal_test_cancel.active" />
    </template>
  </v-layout>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed     from '@/components/ui/buttons/button_red.vue';
import question      from '@/components/view_blocks/Testing/question_wrap.vue';
import testSnackbar  from '@/components/view_blocks/Testing/test_snackbar/test_snackbar';
import courseHeader  from '@/components/view_blocks/Course/course_header';
import courseAside   from '@/components/view_blocks/Course/course_aside';
import courseContent from '@/components/view_blocks/Course/course_content';
import modalSuccess  from '@/components/view_blocks/Testing/testing_modals/modal_success.vue';
import modalFailed   from '@/components/view_blocks/Testing/testing_modals/modal_failed.vue';
import modalTest     from '@/components/view_blocks/Testing/testing_modals/modal_test.vue';
import modalTestCancel    from '@/components/view_blocks/Testing/testing_modals/modal_test_cancel.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import api from '@/api';
import {SCORM} from 'pipwerks-scorm-api-wrapper';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    question,
    testSnackbar,
    buttonRed,
    courseHeader,
    courseAside,
    courseContent,
    modalTest,
    modalSuccess,
    modalFailed,
    modalTestCancel,
  },
  data: function() {
    return {
      isScormCourseShown: false,
      isScormTestStarted: false,
      scormAPI         : null,
      commitInitialized: null,
      isScorm          : {
        type: Boolean,
      },
      scormPath: {
        type: String,
      },
      scormName: {
        type: String,
      },
      objApi: {
        type: null,
      },
    };
  },
  computed: {
    isBusinessPlus() {
      return this.$route.query.is_business_plus;
    },
    isCurrentCourse() {
      console.debug("this.type:", this.type);
      return this.type === 'current';
    },
    isTestFinished() {
      return this.test_finished;
    },
    isDisabledByUserStatus() {
      return this.$route.query.is_disabled_by_user_status;
    },
    parentRoute() {
      const route = this.$route.query.is_business_plus ? '/study_business_plus' : '/study';
      return route;
    },
    currentCourseData() {
      return {
        mandatory: this.$route.params.mandatory,
      };
    },
    if_course_showed: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return this.content_mobile_showed || this.points_required_test === 0;
      } else {
        return true;
      }
    },
    if_stepper_showed: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return !this.content_mobile_showed;
      } else {
        return true;
      }
    },
    ...mapGetters('course_info', [
      'snackbar',
      'course_started',
      'course_completed',
      'test_started',
      'test_finished',
      'test_hided',
      'lessons_passed',
      'lessons_total',
      'content_mobile_showed',
      'course_name',
      'points_required_test',
      'type',
    ]),
    ...mapGetters('testing', ['test_layout']),
    ...mapGetters('course_info/modals', [
      'modal_success',
      'modal_failed',
      'modal_test',
      'modal_test_cancel',
    ]),
    ...mapGetters('cards', ['cards', 'get_card_by_id']),
    ...mapGetters('course_info/steps', [
      'lessons_total',
      'current_lesson',
      'blocks',
      'current_lesson_path',
      'check_lesson_not_passed',
    ]),
    ...mapGetters('course_info/content', ['course_id']),
    ...mapGetters('common', ['loading']),
    ...mapGetters('profile/user', ['user']),
  },
  watch: {
    $route(to, from) {
      this.get_course_by_id(this.$route.params.id);
    },
    type: {
      immediate: false,
      handler: async function(newVal, oldVal) {
        console.debug(newVal, oldVal);
        if (newVal === 'current' && oldVal !== 'current') {
          this.scormPath = this.$route.query.scorm_path;
          this.scormName = this.$route.query.title || '';
          await this.get_course_by_id(this.$route.params.id);

          console.debug("this.scormPath", this.scormPath);

          await this.initializeScorm();
        }
      }
    },
  },
  beforeMount() {
    this.isScorm = this.$route.query.is_scorm;
  },
  async beforeUpdate() {
    // await this.initializeCourse();
  },

  async mounted() {
    console.debug("MOUNTED", this);
    console.debug(
        "iframe statuses:",
        this.isScorm,
        this.isScormCourseShown,
        this.isDisabledByUserStatus,
        this.test_finished,
        this.isCurrentCourse
    );
    if (this.isScorm) {
      if (this.test_finished) {
        this.handleScormCourseShown(true);
      }
      this.scormPath = this.$route.query.scorm_path;
      this.scormName = this.$route.query.title || '';
      await this.get_course_by_id(this.$route.params.id);
      await this.get_course_by_id(this.$route.params.id);
      await this.$store.dispatch('course_info/steps/initializeActiveLesson');

      console.debug("this.scormPath", this.scormPath);

      await this.initializeScorm();
    } else {
      await this.get_course_by_id(this.$route.params.id);
      await this.get_course_by_id(this.$route.params.id);
      await this.$store.dispatch('course_info/steps/initializeActiveLesson');
    }
    this.DISABLE_TEST_LAYOUT();

    if (this.snackbar && !this.test_started) {
      this.DISABLE_SNACKBAR();
    }

    this.TO_LESSON({
      block : this.current_lesson_path[0],
      lesson: this.current_lesson_path[1],
    });

    window.scroll(0, 0);

    console.debug("MOUNTED END current_lesson_path", this.current_lesson_path);
  },
  beforeDestroy() {
    console.debug("beforeDestroy hook");
    // обнулить данные о курсе при демонтаже компонента //
    this.SET_COURSE({
      snackbar              : false,
      test_hided            : false,
      content_mobile_showed : false,
      course_started        : false,
      course_completed      : false,
      test_started          : false,
      test_finished         : false,
      test_result           : false,
      interrupt_test        : false,
      course_name           : '',
      started_course_name   : '',
      started_course_id     : 0,
      current_lesson        : 0,
      next_lesson           : 0,
      lessons_passed        : 0,
      points_earned_test    : 5,
      points_total_test     : 5,
      points_required_test  : 5,
      course_time           : 1,
      course_rest_time      : '',
      expired               : false,
      time_test             : 0,
      date_start            : '',
      date_end              : '',
      mandatory             : false,
      test_attempts         : 0,
      test_remain_in_seconds: 0,
      series                : 0,
      completed_date        : 0,
      time_left             : 0,
      type                  : '',
    });
  },
  methods: {
    ...mapMutations('course_info', [
      'SET_COURSE',
      'DISABLE_SNACKBAR',
      'TOGGLE_SNACKBAR',
      'COMPLETE_COURSE',
    ]),
    ...mapMutations('testing', ['DISABLE_TEST_LAYOUT']),
    ...mapMutations('course_info', ['HIDE_MOBILE', 'SHOW_MOBILE']),
    ...mapMutations('course_info/steps', ['TO_LESSON']),
    ...mapActions('cards', ['get_courses']),
    ...mapActions('course_info', [
      'get_courses_card',
      'get_course_by_id',
      'course_activate',
    ]),
    ...mapActions('testing', [
      'get_test_history',
      'test_hide',
      'start_test',
      'save_test_result',
    ]),
    hide_wrap() {
      this.test_hide();
      this.HIDE_MOBILE();
    },

    handleManualActivationStatusChange(val) {
      console.debug("VAL", val)
      if (val) {
        this.type = 'current';
      }
    },

    handleScormCourseShown(val) {
      this.isScormCourseShown = val;
    },

    handleScormTestStarted(val) {
      this.isScormTestStarted = val;

      // Функция для поиска и нажатия на SVG с data-commandset-id="7"
      const findAndClickSvg = () => {
        try {
          const iframe = this.$refs.scormIframe;
          if (!iframe) {
            console.error('iframe not found');
            return false;
          }

          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          // Ищем SVG с атрибутом data-commandset-id="7"
          const targetSvg = iframeDoc.querySelector('svg[data-commandset-id="7"]');

          if (targetSvg) {

            // Создаем и dispatch события для клика по SVG
            const clickEvents = ['mousedown', 'mouseup', 'click'];
            clickEvents.forEach(eventType => {
              const event = new MouseEvent(eventType, {
                view: iframe.contentWindow,
                bubbles: true,
                cancelable: true,
                clientX: 0,
                clientY: 0
              });
              targetSvg.dispatchEvent(event);
            });

            // Также пытаемся кликнуть на родительский элемент, если SVG вложен в кнопку или ссылку
            let clickableParent = targetSvg.closest('button, a, [onclick]');
            if (clickableParent) {
              clickableParent.click();
            } else {
              // Если нет явного родителя, кликаем по самому SVG
              targetSvg.click();
            }

            return true;
          }

          return false;
        } catch (error) {
          return false;
        }
      };

      // Функция для поиска и нажатия кнопки "Начать тест" (резервный вариант)
      const findAndClickStartButton = () => {
        try {
          const iframe = this.$refs.scormIframe;
          if (!iframe) {
            console.error('iframe not found');
            return false;
          }

          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          // Ищем все кнопки в iframe
          const buttons = iframeDoc.querySelectorAll('button');
          let startButton = null;

          // Ищем кнопку с текстом "Начать тест"
          for (let button of buttons) {
            // Проверяем текст внутри кнопки, включая вложенные span
            const buttonText = button.textContent.trim().toLowerCase();
            if (buttonText === 'начать тест') {
              startButton = button;
              break;
            }

            // Ищем внутри span
            const span = button.querySelector('span');
            if (span) {
              const spanText = span.textContent.trim().toLowerCase();
              if (spanText === 'начать тест') {
                startButton = button;
                break;
              }
            }
          }

          if (startButton) {

            // Создаем и dispatch события для максимальной совместимости
            const clickEvents = ['mousedown', 'mouseup', 'click'];
            clickEvents.forEach(eventType => {
              const event = new MouseEvent(eventType, {
                view: iframe.contentWindow,
                bubbles: true,
                cancelable: true
              });
              startButton.dispatchEvent(event);
            });

            // Дополнительно вызываем click()
            startButton.click();
            return true;
          } else {
            return false;
          }
        } catch (error) {
          return false;
        }
      };

      // Основная логика выполнения
      const executeTestStart = () => {
        // Сначала пытаемся найти и нажать SVG
        const svgClicked = findAndClickSvg();

        // Если SVG не найден, ищем кнопку
        if (!svgClicked) {
          const buttonClicked = findAndClickStartButton();

          if (!buttonClicked) {
            return false;
          }
          return buttonClicked;
        }

        return svgClicked;
      };

      // Запускаем поиск и клик
      const elementClicked = executeTestStart();

      // Если элемент найден и нажат, запускаем SCORM тест
      if (elementClicked) {
        const startScormTest = () => {
          console.debug("Starting SCORM test using window.API...");

          if (!window.API) {
            console.error('window.API not found');
            return false;
          }

          if (!window.API.isInitialized || !window.API.isInitialized()) {
            console.error('SCORM API is not initialized');
            return false;
          }

          console.debug('window.API found and initialized:', window.API);

          try {
            // Устанавливаем статусы для начала тестирования
            window.API.LMSSetValue('cmi.core.lesson_status', 'incomplete');
            window.API.LMSSetValue('cmi.core.score.raw', '0');
            window.API.LMSSetValue('cmi.core.lesson_location', '0');
            window.API.LMSSetValue('cmi.core.lesson_mode', 'normal');
            window.API.LMSSetValue('cmi.core.entry', 'resume');

            // Сохраняем изменения
            const commitResult = window.API.LMSCommit('');
            console.debug('LMSCommit result:', commitResult);

            if (commitResult === 'true') {
              console.debug('SCORM test successfully started via window.API!');
              return true;
            } else {
              console.error('LMSCommit failed');
              return false;
            }
          } catch (error) {
            console.error('Error during SCORM test start:', error);
            return false;
          }
        };

        // Даем небольшой таймаут для обработки клика перед запуском SCORM
        setTimeout(() => {
          if (window.API) {
            startScormTest();
          } else {
            console.error('window.API not available');
          }
        }, 100);
      }

      return elementClicked;
    },

    async initializeCourse() {
      if (this.$route.query) {
        console.debug("INITIALIZE QUERY:", this.$route.query);
      }
      if (this.type === 'newcourse') {
        await api.course.activate_course({
          course_id: Number(this.$route.params.id),
          user_id  : Number(this.user.id),
        }); // первый запуск курса и курс переходит в текущие
        await api.course.test_start(this.$route.params.id); // начало прохождения курса
      } else if (this.type === 'current') {
        await api.course.test_start(this.$route.params.id); // начало прохождения курса
      }
    },

    async initializeScorm() {
      return new Promise(async (resolve) => {
        window.API.reset(); // сброс scorm api до чистого состояния
        const iframeDocument =
            this.$refs.scormIframe.contentDocument ||
            this.$refs.scormIframe.contentWindow.document;
        this.objApi = this.$refs.scormIframe.contentWindow;

        this.$refs.scormIframe.onload = () => {
          this.setupScormApiHandlers(this.objApi);
          this.setupMutationObserver(iframeDocument);
          this.removeUiTab();
        };

        if (SCORM.connection.isActive !== true) {
          SCORM.init();
        }
        window.API_1484_11.reset(); // сброс scorm api 2004 до чистого состояния

        resolve();
      });
    },
    setupMutationObserver(iframeDocument) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const trialBanner = iframeDocument.querySelector('.trial_banner');
            if (trialBanner) {
              trialBanner.remove();
            }
          }
        });
      });

      observer.observe(iframeDocument.body, {
        childList : true,
        subtree   : true,
        attributes: true,
      });
    },

    setupScormApiHandlers(objApi) {
      this.initFunc(objApi);
      this.commitFunc(objApi);
      this.finishFunc(objApi);
    },
    initFunc(objApi) {
      if (objApi.API) {
        this.handleScormInit(objApi.API, 'LMSInitialize');
      } else if (window.API) {
        this.handleScormInit(window.API, 'LMSInitialize');
      }

      if (objApi.API_1484_11) {
        this.handleScormInit(objApi.API_1484_11, 'Initialize');
      } else if (window.API) {
        this.handleScormInit(window.API_1484_11, 'Initialize');
      }
    },
    commitFunc(objApi) {
      if (objApi.API) {
        console.debug("objApi.API commit")
        this.handleCommit(objApi.API, 'LMSCommit');
      } else if (window.API) {
        console.debug("window.API commit")
        this.handleCommit(window.API, 'LMSCommit');
      }

      if (objApi.API_1484_11) {
        this.handleCommit(objApi.API_1484_11, 'Commit');
      } else if (window.API) {
        this.handleCommit(window.API_1484_11, 'Commit');
      }
    },
    finishFunc(objApi) {
      if (objApi.API) {
        console.debug("objApi.API finish")
        this.handleScormFinish(objApi.API, 'LMSFinish');
      } else if (window.API) {
        console.debug("window.API finish")
        this.handleScormFinish(window.API, 'LMSFinish');
      }

      if (objApi.API_1484_11) {
        this.handleScormFinish(objApi.API_1484_11, 'Terminate');
      } else if (window.API) {
        this.handleScormFinish(window.API_1484_11, 'Terminate');
      }
    },

    handleCommit(scormApi, method) {
      console.debug("handleCommit", scormApi, method);
      scormApi.on(method, async () => {
        // Получаем основной статус урока
        let lessonStatus = scormApi.cmi.core
            ? scormApi.LMSGetValue('cmi.core.lesson_status')
            : scormApi.LMSGetValue('cmi.success_status');

        // Если тестирование завершено, собираем детальную информацию
        if (['passed', 'failed', 'completed'].includes(lessonStatus)) {
          // console.debug('Тестирование завершено со статусом:', lessonStatus);

          // Сбор детальных результатов
          const testResults = {
            lessonStatus: lessonStatus,
            scoreRaw: scormApi.LMSGetValue('cmi.core.score.raw'), // Набранные баллы
            scoreMax: scormApi.LMSGetValue('cmi.core.score.max'), // Максимальный балл
            scoreMin: scormApi.LMSGetValue('cmi.core.score.min'), // Минимальный балл
            totalTime: scormApi.LMSGetValue('cmi.core.total_time'), // Затраченное время
            sessionTime: scormApi.LMSGetValue('cmi.core.session_time'), // Время текущей сессии
            lessonLocation: scormApi.LMSGetValue('cmi.core.lesson_location'), // Местоположение
            scormCourseId: this.$route.params.id,
          };

          console.debug('Детальные результаты теста:', testResults);

          // Отправляем результаты на сервер
          // await api.course.scorm_test_end(this.$route.params.id, testResults);
        }

        this.removeUiTab();
      });
    },

    handleScormInit(api, method) {
      api.on(method, () => {
        console.debug("scorm init", api, method)
        this.removeUiTab();
      });
    },

    removeUiTab() {
      const iframeDocument =
          this.$refs.scormIframe.contentDocument ||
          this.$refs.scormIframe.contentWindow.document;

      const bannerUiScorm = iframeDocument.querySelector('.trial_banner');

      if (!!bannerUiScorm) {
        bannerUiScorm.remove();
      }
    },

    handleScormFinish(api, method) {
      console.debug("finish", api, method);
      api.on(method, () => {
        console.debug("finishEvent", api, method);
        const allScore = api.cmi.interactions.childArray.length * 5;

        let lessonStatus = api.cmi.core
            ? api.cmi.core.lesson_status
            : api.cmi.success_status;

        const oneQustionWeight = 5;

        let absoluteScore = 0;
        let percentScore = 0;

        api.cmi.interactions.childArray.forEach((question) => {
          if (question.result === 'correct') {
            absoluteScore += oneQustionWeight;
          } else if (question._result === 'correct') {
            absoluteScore += oneQustionWeight;
          }
        });

        percentScore = Number((100 / allScore) * absoluteScore);
        console.log("finishStats", allScore, absoluteScore, percentScore);


        if (this.type !== 'finished' && !isNaN(percentScore)) {
          this.finish_check_scorm(
              this.$route.params.id,
              percentScore,
              absoluteScore,
              lessonStatus
          );
        }
      });
    },
    async finish_check_scorm(id, percent, score, status) {
      try {
        await api.course.save_test_end(id, {
          percent: percent,
          score  : score,
          status : status,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style>
.scorm-course {
  flex: 1 0 auto;
}
</style>
